import {
  subscribeToProfile,
  unsubscribeFromProfile
} from '@/store/lists/operations';
import { selectProfileIsFavorite } from '@/store/lists/selectors/selectProfileIsFavorite';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AddToFavoritesStyled } from '@/components/Shared/AddToFavorites.style';
import {
  useActiveProfile,
  useTokenState
} from '@/store/localStorage/useTokenState';
import { AddToFavoritesIcon } from '@/styles/Icons/AddToFavorites';

export function AddToFavorites({ profile, sidebarMode = false }) {
  const dispatch = useDispatch();
  const { activeProfileId } = useActiveProfile();
  const [token] = useTokenState();
  const isFavorite = useSelector(state =>
    selectProfileIsFavorite(state, profile.id)
  );
  const [waiting, setWaiting] = useState(false);
  const [favorite, setFavorite] = useState(isFavorite);

  useEffect(() => {
    setFavorite(isFavorite);
    // I don't want it to be triggered on isFavorite change.
    // eslint-disable-next-line
  }, [profile.id]);

  const toggleSubscription = async () => {
    if (waiting) return;
    setWaiting(true);
    setFavorite(!favorite);
    const toggleFn = favorite ? unsubscribeFromProfile : subscribeToProfile;
    const res = await dispatch(toggleFn({ profile, token, activeProfileId }));
    if (!res?.payload && res !== true) {
      setFavorite(!favorite);
    }
    setWaiting(false);
  };

  return (
    <AddToFavoritesStyled
      title={favorite ? 'удалить из избранного' : 'добавить в избранное'}
      active={favorite}
      sidebarMode={sidebarMode}
      onClick={toggleSubscription}
    >
      <AddToFavoritesIcon />
    </AddToFavoritesStyled>
  );
}
